/**
 * Pure function to get 3P product keys for a given filter ID.
 * Uses pre-computed static mapping instead of ThirdPartyConfigs
 * to avoid importing React icon components.
 */
import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import { thirdPartyFilterProducts } from '../../constants/3p-product-configs/product-keys-3p';
import type { FilterId } from '../../constants/filters';

export const getProducts3PFromConfigForFilter = (filterId: FilterId): ProductKeys3P[] => {
	return thirdPartyFilterProducts[filterId] ?? [];
};
